import React, { useState } from "react";
import PageHeader from "../component/layout/pageheader";
import GoogleMap from "../component/section/googlemap";
import LoaderComponent from "../component/loader/LoaderComponent";
import { toastMaker, validateEmail } from "../utils/utility";
import matrimonyInstance from "../utils/axios";
import { CONTACT_US } from "../API_LIST";

let ContactInfoList = [
	{
		imgUrl: "assets/images/contact/location.svg",
		imgAlt: "contact info thumb",
		infoTitle: "Office Address",
		infoDesc: "Dallas, Texas United States of America",
	},
	{
		imgUrl: "assets/images/contact/email.svg",
		imgAlt: "contact info thumb",
		infoTitle: "Send Mail",
		infoDesc: "support@batus.org",
	},
	{
		imgUrl: "assets/images/contact/phone.svg",
		imgAlt: "contact info thumb",
		infoTitle: "Phone Number",
		infoDesc: "+1 707 564 6228",
	},
];

const ContactPage = () => {
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		message: "",
	});
	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		const { name, value, pattern } = e.target;
		let formattedValue = value;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!formData.name) {
			return toastMaker("Name field is missing", "error");
		}
		if (!formData.email) {
			return toastMaker("Email field is missing", "error");
		}
		if (!formData.message) {
			return toastMaker("Message field is missing", "error");
		}
		if (!validateEmail(formData?.email)) {
			return toastMaker("Enter a valid email", "error");
		}

		setLoading(true);
		matrimonyInstance
			.post(CONTACT_US, formData)
			.then((response) => {
				setLoading(false);
				toastMaker("Email Sent", "success");
				setFormData({
					name: "",
					email: "",
					message: "",
				});
			})
			.catch((error) => {
				setLoading(false);
				toastMaker(error, "Error");
			});
	};

	return (
		<React.Fragment>
			<div className="contact-section">
				{loading && <LoaderComponent />}
				<div className="contact-top padding-tb aside-bg padding-b">
					<div className="container">
						<div className="row g-5">
							<div className="col-md-12 col-8 col-lg-8 pe-lg-5">
								<article
									className="contact-form-wrapper"
									style={{ background: "none" }}
								>
									<div className="contact-form">
										<h4 className="mb-20">Contact Us</h4>
										<form
											onSubmit={handleSubmit}
											id="commentform"
											className="comment-form"
										>
											<input
												type="text"
												name="name"
												id="item01"
												placeholder="Name*"
												value={formData.name}
												pattern="^[a-zA-Z ]+$"
												onChange={handleChange}
											/>
											<input
												type="text"
												name="email"
												id="item02"
												placeholder="Email *"
												value={formData.email}
												onChange={handleChange}
											/>
											<textarea
												rows="5"
												id="item05"
												name="message"
												placeholder="Your Message"
												className="p-10"
												value={formData.message}
												onChange={handleChange}
											></textarea>
											<button type="submit" className="button login-btn mt-20">
												<span>Send Message</span>
											</button>
										</form>
									</div>
								</article>
							</div>
							<div className="col-md-12 col-4 col-lg-4 ps-lg-5">
								<div
									className="contact-info-wrapper"
									style={{ background: "none" }}
								>
									<div className="contact-info-title">
										<h5 className="mb-15">Contact Details</h5>
										<h5 className="mb-20">Brahmin Association of Texas</h5>
									</div>
									<div className="contact-info-content">
										{ContactInfoList.map((val, i) => (
											<div
												className="contact-info-item d-flex align-items-center gap-3"
												key={i}
											>
												<div className="contact-info-thumb">
													<img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
												</div>
												<div className="contact-info-details">
													<p>{val.infoDesc}</p>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<GoogleMap />
			</div>
		</React.Fragment>
	);
};

export default ContactPage;
